export default "__VITE_ASSET__euM7a1qc__"